import Breadcrumb from '@components/common/breadcrumb'
import { FastlyImage } from '@components/common/image'
import { CODING_FOR_KIDS_ITEMS } from '@lib/data/breadcrumb'
import Ratings from '@components/common/ratings'
import PhoneInputContainer from '@containers/phone-input'
import { t } from '@lingui/macro'
import { useEffect, useRef, useState } from 'react'
import PriceSlotsOverview from '@components/home/price-slots-overview'
import StudentCountriesOverview from '@components/home/student-countries-overview'
import FixedMobileCTA from '@components/course-landing-page/fixed-mobile-cta'
import Partners from '@components/locale-pages/home/us/partners'

const IMAGE_PATH = '/images/coding-for-kids/'

const FirstFold = () => {
  const [isFixedMobileCTAVisible, setIsFixedMobileCTAVisible] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const showFixedCTAOnScroll = (event: any) => {
    if (!containerRef.current) return
    const { offsetTop, offsetHeight } = containerRef.current
    const scrollTopPosition = event.target.documentElement?.scrollTop ?? 0
    setIsFixedMobileCTAVisible(offsetTop + offsetHeight < scrollTopPosition)
  }

  useEffect(() => {
    // Auto-focus on phone input field on page load
    document.getElementById('phone')?.focus()

    // Show fixed CTA upon scrolling on mobile view
    window.addEventListener('scroll', showFixedCTAOnScroll)
    return () => window.removeEventListener('scroll', showFixedCTAOnScroll)
  }, [])

  return (
    <>
      <FixedMobileCTA hideBtn={isFixedMobileCTAVisible} />
      <div
        className="relative flex justify-between px-5 md:px-3 overflow-visible lg:rounded-b-lg hero-gradient-white-orange"
        ref={containerRef}
      >
        <div className="flex text-grey container mx-auto">
          <div className="pt-8 z-10 flex flex-col items-center space-y-5 lg:items-start text-left">
            <div className="self-start">
              <Breadcrumb items={CODING_FOR_KIDS_ITEMS} />
            </div>
            <h1 className="max-w-2xl font-600 text-left custom-home-h1">
              Coding for kids - 8 free coding resources to start their coding
              journey
            </h1>
            {/* phone number input */}

            <p className="text-lg text-left mb-0 mt-4 max-w-2xl leading-normal">
              Codingal helps kids learn AI & coding through live online classes
              led by expert computer science instructors. Parents can also start
              with free coding resources for kids like quizzes, worksheets,
              competitions, webinars, and guides. When your child is ready, book
              a free AI & coding trial lesson and build a mini project in class.
            </p>
            <div className="text-left w-full sm:w-auto pt-5">
              <PhoneInputContainer
                isErrorDarkRed
                buttonText={t`Try a free lesson`}
                isInHomePage
              />
              <div className="mt-3 mb-3 lg:mb-8">
                <PriceSlotsOverview />
              </div>
            </div>

            <div className="flex flex-col md:flex-row md:space-x-8 space-y-5 md:space-y-0 justify-center lg:justify-start pb-6 lg:pb-0">
              <StudentCountriesOverview isTextWhite={false} />
              <Ratings isDarkText />
            </div>
          </div>

          <div className="hidden lg:block relative text-center">
            <div className="relative mx-10">
              <FastlyImage
                src={`${IMAGE_PATH}hero-picture-v2.png`}
                webpSrc={`${IMAGE_PATH}hero-picture-v2.webp`}
                height={550}
                width={550}
                alt="Free Online Coding For Kids"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="relative">
        <Partners />
      </div>
    </>
  )
}
export default FirstFold
